import { motion } from "motion/react";

import LoanApplication from "../components/lender-application-details";
import settings from "../settings";

const Details = () => {
  return (
    <motion.div
      className="h-full"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={settings.routeAnimation.pageVariants}
      transition={settings.routeAnimation.pageTransition}
    >
      <LoanApplication />
    </motion.div>
  );
};

export default Details;
